import { request } from '@zsdx/material-utils';

/**
 * 企业IM账号签名
 */
export const getCompanySign = (accountId?: string) => {
    return request.post<PLATFORM_SERVICE_API.CompanySignResp>('/im/user/companySign', {
        accountId
    });
};

/**
 * 获取待转接技能组
 */
export function getExchangeKfGroup() {
    return request.post<PLATFORM_SERVICE_API.ExchangeKfGroupResp[]>(
        '/session/getExchangeKfGroup',
        {}
    );
}

/**
 * 接受并回复用户消息
 */
export function automaticReply(params: PLATFORM_SERVICE_API.ReceiveAndReplyMsgReq) {
    return request.post('/session/faq/automaticReply', params);
}

/**
 * 点赞或踩
 */
export function praiseOrStep(params: PLATFORM_SERVICE_API.PraiseOrStepReq) {
    return request.post('/session/clickGoodsOrBad', params);
}

/**
 * 批量接受并回复用户消息
 */
export function batchReceiveAndReplyMsg(params: PLATFORM_SERVICE_API.BatchReceiveAndReplyMsgReq) {
    return request.post<PLATFORM_SERVICE_API.BatchReceiveAndReplyMsgResp>(
        '/session/batchReceiveAndReplyMsg',
        params
    );
}
